// NotFound.js
//
//  Updated 3/1.
//
//  Abstract: Page not found.

//	React
import React, { useState } from 'react';
//	Hooks
import useFetch from '../../hooks/useFetch.js';
//  Components
import MuiPhoneNumber from 'material-ui-phone-number'
import CardTemplate from '../__common__/CardTemplate/CardTemplate.js';

//	Material-ui styles
import { 
    makeStyles, 
    Typography, 
    Grid, 
    Button, 
    CircularProgress, 
    Link, 
    TextField 
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%',
        marginTop: theme.spacing(3),
        textAlign: 'center'
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    progess: {
        position: 'absolute'
    },
    logos: {
        width: '125px',
    },
    gridItem: {
        textAlign: 'center'
    }
}));


export default function Register(props) {

    //	CSS classes
    const classes = useStyles();

    const { post } = useFetch();

    //	Set state.
    const [requestSubject, setRequestSubject] = useState('');
    const [message, setMessage] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [errors, setErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    //	Event handlers.
    function handleRequestSubjectChange(event) {
        setRequestSubject(event.target.value);
    }
    function handleMessageChange(event) {
        setMessage(event.target.value);
    }
    function handleEmailChange(event) {
        setEmail(event.target.value);
    }
    function handlePhoneNumberChange(event) {
        setPhoneNumber(event.target.value);
    }

    function handleSubmit(event) {
        event.preventDefault();
        setIsLoading({ isLoading: true });
        const supportRequest = {
            requestSubject: requestSubject,
            message: message
        };
        post('/support', supportRequest)
            .then((response) => {
                setIsLoading(false);
            })
            .catch((error) => {
                setErrors(error.response.data);
                setIsLoading(false);
            });
    }

    return (
        <>
        <CardTemplate backgroundColor='blue' cardMaxWidth={'xs'}>
            <form className={classes.form} noValidate>
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignContent="center"
                    spacing={5}>

                    <Grid item >
                        <Typography variant="h4">
                            Page not found
                        </Typography>
                    </Grid>
                    <Grid item >
                        <Typography variant="h5">
                            HTTP 404
                        </Typography>
                    </Grid>
                <Grid item >
                    <Link href="/login" variant="body2" color="secondary">
                        {"Return to Login"}
                    </Link>
                </Grid>
                </Grid>
            </form>
            </CardTemplate>
        </>
    );
}